// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"lZ-z","inlineTitle":"mZ-z","sponsoredAdsWrapper":"nZ-z","marketplaceRecosWrapper":"oZ-z"};